namespace TabAurous.OMS {
    export namespace TrialBalanceService {
        export const baseUrl = 'Reports/TrialBalance';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<LedgerPostingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Reports/TrialBalance/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>TrialBalanceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
